import { render, staticRenderFns } from "./CreatePoint.vue?vue&type=template&id=3587882e&scoped=true&"
import script from "./CreatePoint.vue?vue&type=script&lang=js&"
export * from "./CreatePoint.vue?vue&type=script&lang=js&"
import style0 from "./CreatePoint.vue?vue&type=style&index=0&id=3587882e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3587882e",
  null
  
)

export default component.exports